import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBd4qJn1EqLKWQUE-q6Z8FLUc0q6m-PHkk",
  authDomain: "dahab-5b236.firebaseapp.com",
  projectId: "dahab-5b236",
  storageBucket: "dahab-5b236.firebasestorage.app",
  messagingSenderId: "858075428785",
  appId: "1:858075428785:web:95f145405d5a49aa6aef90",
  measurementId: "G-Y34KZCRYMK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
